import * as types from './mutation-types'

export const setSellers2 = ({ commit }, sellerList) => {
  const sellers = sellerList.reduce((m, s) => {
    m[s.sellerId.value] = s
    return m
  }, {})
  commit(types.SET_SELLERS, sellers)
}



// WEBPACK FOOTER //
// ./src/store/actions.js